/* ==========================================================================
   Oh!My Snacks · pesquisa — comportamento (alteracoes/pesquisa/, 2026-10-17)
   --------------------------------------------------------------------------
   Três coisas:
     1. as sugestões ao escrever, no painel e no campo da página /search
     2. o painel que a lupa do header abre, em todas as páginas
     3. na página de resultados, as fichas que juntam ao carrinho e o «ver mais»

   AS SUGESTÕES SÃO UMA SECÇÃO DO TEMA, PEDIDA PELO NOME. O pedido vai ao
   `/search/suggest` (a rota vem do Liquid, com o prefixo de mercado) com
   `section_id=oms-pesquisa-sugestoes`, e a Shopify devolve-a já desenhada, nas
   três línguas e com o preço do mercado. Se essa secção sair do tema, a loja
   responde 404 e a lista não aparece: foi o que aconteceu à do Dawn a
   2026-09-09. O nome dela está aqui como texto, e só aqui.

   O CONTRATO COM O RESTO DO SITE, herdado do `oms-gb.js`:
   · a rota do carrinho vem do Liquid (`routes.cart_add_url`), nunca escrita à mão;
   · depois de a Shopify aceitar, avisa a gaveta com `oms:carrinho:entrou`, que é o
     que a abre (`oms-carrinho.js`);
   · o número do saco não é daqui: o `oms-ohm.js` vê o pedido a `/cart/add` sozinho.

   O foco vai para o campo DENTRO do clique na lupa, e não depois: o Safari do
   iPhone só abre o teclado a um `focus()` feito no próprio gesto.
   ========================================================================== */
(function () {
  'use strict';
  if (window.omsPesquisa) return;
  window.omsPesquisa = true;

  var reduz = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var MIN = 2;
  var ESPERA = 160;
  var LIMITE = 6;

  function lerJSON(sel) {
    var el = document.querySelector(sel);
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  /* A configuração vem do painel (em todas as páginas) ou da página de resultados. */
  var C = lerJSON('[data-oms-pesquisa-cfg]') || lerJSON('[data-oms-pesquisa-textos]');
  if (!C || !C.sugestoes) return;

  var cache = new Map();

  function urlSugestoes(q) {
    return C.sugestoes + '?q=' + encodeURIComponent(q) +
      '&section_id=' + encodeURIComponent(C.seccao || 'oms-pesquisa-sugestoes') +
      '&resources%5Btype%5D=product%2Ccollection%2Cpage' +
      '&resources%5Blimit%5D=' + LIMITE +
      '&resources%5Blimit_scope%5D=each' +
      '&resources%5Boptions%5D%5Bunavailable_products%5D=last';
  }

  /* ---------- 1. as sugestões ---------- */

  function ligar(campo, caixa, op) {
    var form = campo.form;
    var limpar = form && form.querySelector('[data-limpar]');
    var controlador = null;
    var temporizador = null;
    var ativo = -1;
    var mostrado = '';

    function opcoes() {
      return Array.prototype.slice.call(caixa.querySelectorAll('[role="option"]'));
    }

    function marcar(i) {
      var lista = opcoes();
      lista.forEach(function (o, j) { o.setAttribute('aria-selected', j === i ? 'true' : 'false'); });
      ativo = i;
      if (i >= 0 && lista[i]) {
        campo.setAttribute('aria-activedescendant', lista[i].id);
        lista[i].scrollIntoView({ block: 'nearest' });
      } else {
        campo.removeAttribute('aria-activedescendant');
      }
    }

    function abrirLista() {
      caixa.hidden = false;
      campo.setAttribute('aria-expanded', 'true');
    }

    function fecharLista() {
      caixa.hidden = true;
      campo.setAttribute('aria-expanded', 'false');
      marcar(-1);
    }

    function anunciar() {
      if (!op.estado) return;
      var nada = caixa.querySelector('[data-nada]');
      if (nada) { op.estado.textContent = nada.textContent; return; }
      var n = opcoes().length - (caixa.querySelector('[id$="oms-sug-todos"]') ? 1 : 0);
      op.estado.textContent = n === 1 ? C.um : String(C.varios || '').replace('[n]', n);
    }

    function pintar(html, q) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var raiz = doc.querySelector('[data-oms-sug]');
      if (!raiz) return;
      /* Dois `id` iguais na mesma página partem o `aria-activedescendant`: na
         página de pesquisa há duas listas destas ao mesmo tempo. */
      raiz.querySelectorAll('[id]').forEach(function (el) { el.id = op.prefixo + el.id; });
      raiz.querySelectorAll('[aria-labelledby]').forEach(function (el) {
        el.setAttribute('aria-labelledby', op.prefixo + el.getAttribute('aria-labelledby'));
      });
      caixa.classList.toggle('so-produtos', raiz.classList.contains('so-produtos'));
      caixa.innerHTML = raiz.innerHTML;
      mostrado = q;
      marcar(-1);
      abrirLista();
      anunciar();
      if (op.aoPintar) op.aoPintar();
    }

    function pedir(q) {
      if (cache.has(q)) { pintar(cache.get(q), q); return; }
      if (controlador) controlador.abort();
      var este = new AbortController();
      controlador = este;
      caixa.setAttribute('aria-busy', 'true');
      if (op.estado) op.estado.textContent = C.a_pesquisar || '';
      fetch(urlSugestoes(q), { signal: este.signal, headers: { Accept: 'text/html' } })
        .then(function (r) {
          if (!r.ok) throw new Error(String(r.status));
          return r.text();
        })
        .then(function (html) {
          cache.set(q, html);
          if (campo.value.trim() === q) pintar(html, q);
        })
        .catch(function () { /* fica a lista que estava; a página de resultados continua a um Enter */ })
        .finally(function () { if (controlador === este) caixa.removeAttribute('aria-busy'); });
    }

    function aoEscrever() {
      var q = campo.value.trim();
      if (limpar) limpar.hidden = campo.value === '';
      clearTimeout(temporizador);
      if (q.length < MIN) {
        if (controlador) controlador.abort();
        mostrado = '';
        fecharLista();
        if (op.aoVazio) op.aoVazio(true);
        return;
      }
      if (q === mostrado && !caixa.hidden) return;
      temporizador = setTimeout(function () { pedir(q); }, cache.has(q) ? 0 : ESPERA);
    }

    campo.addEventListener('input', aoEscrever);

    campo.addEventListener('keydown', function (e) {
      var lista = opcoes();
      if (e.key === 'ArrowDown') {
        if (caixa.hidden) { if (campo.value.trim().length >= MIN) { e.preventDefault(); aoEscrever(); } return; }
        if (!lista.length) return;
        e.preventDefault();
        marcar(ativo + 1 >= lista.length ? 0 : ativo + 1);
      } else if (e.key === 'ArrowUp') {
        if (caixa.hidden || !lista.length) return;
        e.preventDefault();
        marcar(ativo === -1 ? lista.length - 1 : ativo - 1);
      } else if (e.key === 'Enter') {
        if (ativo >= 0 && lista[ativo]) {
          var a = lista[ativo].querySelector('a[href]');
          if (a) { e.preventDefault(); a.click(); }
        }
      } else if (e.key === 'Escape') {
        if (ativo >= 0) { e.preventDefault(); e.stopPropagation(); marcar(-1); }
        else if (!caixa.hidden && op.fechaComEscape) { e.preventDefault(); e.stopPropagation(); fecharLista(); }
      }
    });

    if (form) {
      form.addEventListener('submit', function (e) {
        if (campo.value.trim() === '') { e.preventDefault(); campo.focus(); }
      });
    }

    if (limpar) {
      limpar.addEventListener('click', function () {
        campo.value = '';
        aoEscrever();
        campo.focus();
      });
    }

    if (op.fechaFora) {
      document.addEventListener('click', function (e) {
        if (caixa.hidden) return;
        if (caixa.contains(e.target) || (form && form.contains(e.target))) return;
        fecharLista();
      });
      campo.addEventListener('focus', function () {
        if (campo.value.trim().length >= MIN && mostrado === campo.value.trim() && caixa.innerHTML) abrirLista();
      });
    }

    return {
      mostrar: function () { if (campo.value.trim().length >= MIN) aoEscrever(); },
      fechar: fecharLista
    };
  }

  /* ---------- 2. o painel da lupa ---------- */

  var painel = document.querySelector('[data-oms-pesquisa]');
  var lupa = document.querySelector('.ohm-nav a.lupa');

  if (painel && lupa) {
    var campoP = painel.querySelector('[data-campo]');
    var caixaP = painel.querySelector('[data-sugestoes]');
    var inicio = painel.querySelector('[data-inicio]');
    var folhaCss = document.querySelector('[data-oms-pesquisa-css]');
    var aberto = false;
    var aFechar = null;

    var sugP = ligar(campoP, caixaP, {
      prefixo: 'p-',
      estado: painel.querySelector('[data-estado]'),
      aoVazio: function () { if (inicio) inicio.hidden = false; },
      aoPintar: function () { if (inicio) inicio.hidden = !caixaP.querySelector('[data-nada]'); }
    });

    lupa.setAttribute('aria-haspopup', 'dialog');
    lupa.setAttribute('aria-controls', painel.id);
    lupa.setAttribute('aria-expanded', 'false');

    var abrir = function (e) {
      if (e) {
        if (e.defaultPrevented || e.button > 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
        e.preventDefault();
      }
      if (aberto) { campoP.focus(); return; }
      /* o menu do telemóvel fecha-se primeiro: os dois painéis não se empilham */
      if (document.body.classList.contains('menu-aberto')) {
        var bt = document.querySelector('.ohm-nav .menu-bt');
        if (bt) bt.click();
      }
      /* a folha carrega sem bloquear a página; se ainda não chegou, passa a valer já */
      if (folhaCss && folhaCss.media !== 'all') folhaCss.media = 'all';
      clearTimeout(aFechar);
      painel.hidden = false;
      aberto = true;
      document.documentElement.classList.add('oms-pesquisa-aberta');
      lupa.setAttribute('aria-expanded', 'true');
      try { campoP.focus({ preventScroll: true }); } catch (x) { campoP.focus(); }
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { if (aberto) painel.classList.add('aberto'); });
      });
      sugP.mostrar();
    };

    var fechar = function () {
      if (!aberto) return;
      aberto = false;
      painel.classList.remove('aberto');
      document.documentElement.classList.remove('oms-pesquisa-aberta');
      lupa.setAttribute('aria-expanded', 'false');
      aFechar = setTimeout(function () { painel.hidden = true; }, reduz ? 0 : 280);
      try { lupa.focus({ preventScroll: true }); } catch (x) { lupa.focus(); }
    };

    lupa.addEventListener('click', abrir);

    painel.addEventListener('click', function (e) {
      if (e.target.closest('[data-fechar]')) fechar();
    });

    painel.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !e.defaultPrevented) { e.preventDefault(); fechar(); return; }
      if (e.key !== 'Tab') return;
      /* o foco não sai do painel enquanto ele está aberto */
      var focaveis = Array.prototype.filter.call(
        painel.querySelectorAll('a[href], button, input:not([type="hidden"])'),
        function (el) { return !el.disabled && el.getAttribute('tabindex') !== '-1' && el.offsetParent !== null; }
      );
      if (!focaveis.length) return;
      var primeiro = focaveis[0];
      var ultimo = focaveis[focaveis.length - 1];
      if (e.shiftKey && document.activeElement === primeiro) { e.preventDefault(); ultimo.focus(); }
      else if (!e.shiftKey && document.activeElement === ultimo) { e.preventDefault(); primeiro.focus(); }
    });

    /* «/» abre a pesquisa no computador, como em quase todo o lado */
    document.addEventListener('keydown', function (e) {
      if (e.key !== '/' || aberto || e.metaKey || e.ctrlKey || e.altKey) return;
      var t = e.target;
      if (t && (t.isContentEditable || /^(INPUT|TEXTAREA|SELECT)$/.test(t.tagName))) return;
      e.preventDefault();
      abrir();
    });

    /* quem volta atrás para uma página que tinha o painel aberto encontra-a limpa */
    addEventListener('pageshow', function (e) { if (e.persisted && aberto) fechar(); });
  }

  /* ---------- 3. a página de resultados ---------- */

  var campoG = document.querySelector('.oms-pesquisa-cabeca [data-campo]');
  var caixaG = document.querySelector('.oms-pesquisa-cabeca [data-sugestoes]');
  var pagina = document.querySelector('[data-oms-resultados]');
  var voz = pagina && pagina.querySelector('[data-voz]');

  if (campoG && caixaG) {
    ligar(campoG, caixaG, { prefixo: 'g-', estado: voz, fechaFora: true, fechaComEscape: true });
  }

  if (!pagina) return;
  var T = lerJSON('[data-oms-pesquisa-textos]') || {};

  function quantos(ficha) {
    return Math.min(99, Math.max(1, Number(ficha.dataset.entrar) || 1));
  }

  function mostrarQuantos(ficha) {
    var o = ficha.querySelector('.passo output');
    if (o) o.textContent = quantos(ficha);
  }

  function aviso(ficha, texto) {
    var p = ficha.querySelector('.oms-aviso');
    if (!texto) { if (p) p.remove(); return; }
    if (!p) {
      p = document.createElement('p');
      p.className = 'oms-aviso';
      p.setAttribute('role', 'alert');
      ficha.appendChild(p);
    }
    p.textContent = texto;
  }

  function juntar(ficha, bt) {
    if (bt.getAttribute('aria-busy') === 'true') return;
    var variante = Number(ficha.dataset.variante);
    if (!variante || !T.rota_add) return;
    bt.setAttribute('aria-busy', 'true');
    aviso(ficha, '');
    fetch(T.rota_add, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variante, quantity: quantos(ficha) }] })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        if (!res.ok || (res.d && res.d.status)) throw new Error((res.d && res.d.description) || '');
        ficha.dataset.entrar = 1;
        mostrarQuantos(ficha);
        var curto = bt.querySelector('.curto');
        var antes = curto ? curto.textContent : '';
        ficha.classList.add('juntou');
        if (curto && T.adicionado) curto.textContent = T.adicionado;
        setTimeout(function () {
          ficha.classList.remove('juntou');
          if (curto) curto.textContent = antes;
        }, 1800);
        if (voz && T.adicionado_voz) voz.textContent = T.adicionado_voz;
        document.dispatchEvent(new CustomEvent('oms:carrinho:entrou', {
          detail: { origem: 'pesquisa', variante: variante }
        }));
      })
      .catch(function (e) { aviso(ficha, e.message); })
      .finally(function () { bt.removeAttribute('aria-busy'); });
  }

  /* O «ver mais» acrescenta a página seguinte à grelha, e o link fica a apontar
     para a outra a seguir. Sem JavaScript é um link normal. */
  function acrescentar(bt) {
    if (bt.getAttribute('aria-busy') === 'true') return;
    var url = bt.getAttribute('href');
    var seccao = pagina.closest('.shopify-section');
    var id = seccao && seccao.id ? seccao.id.replace(/^shopify-section-/, '') : '';
    if (!id) { location.href = url; return; }
    var grelha = pagina.querySelector('[data-grelha]');
    var caixaMais = pagina.querySelector('[data-mais-caixa]');
    var antes = bt.textContent;
    bt.setAttribute('aria-busy', 'true');
    if (T.a_carregar) bt.textContent = T.a_carregar;
    fetch(url + (url.indexOf('?') === -1 ? '?' : '&') + 'section_id=' + encodeURIComponent(id))
      .then(function (r) { if (!r.ok) throw new Error(String(r.status)); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var nova = doc.querySelector('[data-grelha]');
        if (nova && grelha) {
          Array.prototype.slice.call(nova.children).forEach(function (f) { grelha.appendChild(f); });
        }
        var novaCaixa = doc.querySelector('[data-mais-caixa]');
        if (novaCaixa && caixaMais) caixaMais.replaceWith(novaCaixa);
        else if (caixaMais) caixaMais.remove();
      })
      .catch(function () { location.href = url; })
      .finally(function () { bt.removeAttribute('aria-busy'); bt.textContent = antes; });
  }

  pagina.addEventListener('click', function (e) {
    var ficha = e.target.closest('[data-ficha]');
    if (ficha) {
      if (e.target.closest('[data-mais]')) { ficha.dataset.entrar = quantos(ficha) + 1; mostrarQuantos(ficha); return; }
      if (e.target.closest('[data-menos]')) { ficha.dataset.entrar = quantos(ficha) - 1; mostrarQuantos(ficha); return; }
      var bt = e.target.closest('[data-juntar]');
      if (bt) { e.preventDefault(); juntar(ficha, bt); return; }
    }
    var mais = e.target.closest('[data-mais-btn]');
    if (mais) { e.preventDefault(); acrescentar(mais); }
  });
})();
